import { useLayoutEffect, useRef, useState } from "react";

const FADE_DURATION_MS = 300;
const CLEANUP_BUFFER_MS = 50;

const Crossfade = ({ transitionKey, className = "", children }) => {
  const [outgoingLayers, setOutgoingLayers] = useState([]);
  const previousKeyRef = useRef(transitionKey);
  const previousChildrenRef = useRef(children);

  useLayoutEffect(() => {
    if (previousKeyRef.current === transitionKey) {
      previousChildrenRef.current = children;
      return;
    }
    setOutgoingLayers(layers => [
      ...layers,
      {
        id: `${String(previousKeyRef.current)}-${Date.now()}`,
        node: previousChildrenRef.current,
      },
    ]);
    previousKeyRef.current = transitionKey;
    previousChildrenRef.current = children;
  }, [transitionKey, children]);

  useLayoutEffect(() => {
    if (outgoingLayers.length === 0) return undefined;
    const timer = setTimeout(
      () => setOutgoingLayers([]),
      FADE_DURATION_MS + CLEANUP_BUFFER_MS,
    );
    return () => clearTimeout(timer);
  }, [outgoingLayers.length]);

  const isCrossfading = outgoingLayers.length > 0;

  return (
    <div className={`relative ${className}`}>
      {outgoingLayers.map(layer => (
        <div
          key={layer.id}
          className="pointer-events-none absolute inset-0 animate-fade-out"
        >
          {layer.node}
        </div>
      ))}
      <div
        key={transitionKey}
        className={`absolute inset-0 ${isCrossfading ? "animate-fade-in" : ""}`}
      >
        {children}
      </div>
    </div>
  );
};

export default Crossfade;
